import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import { tokens as c } from '../theme';
import { IconCircle } from './modern';

/**
 * The balance at the top of My wallet (wave 3, W2 look): a white card with
 * the wallet icon on a green tint, the label, the amount in large tabular
 * figures, and the page's buttons under it. Used only by views/UserWallet.js.
 *
 *   <WalletCard title={t('Balance')} amount="ETB 1,240.5" actions={<Button>...</Button>} />
 *
 * `children` is still drawn under the amount (the old props.children slot).
 */
export default function WalletCard({ title, amount, actions, children, sx }) {
  return (
    <Paper
      component="section"
      aria-label={typeof title === 'string' ? title : undefined}
      sx={{ p: { xs: 2, md: 2.5 }, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0, ...(sx || {}) }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
        <IconCircle icon={<AccountBalanceWalletOutlinedIcon />} hue="success" size={44} />
        <Box sx={{ minWidth: 0 }}>
          <Typography component="h2" sx={{ fontSize: 14, fontWeight: 600, lineHeight: 1.4, color: c.INK_2 }}>
            {title}
          </Typography>
          {amount !== undefined && amount !== null ? (
            <Typography
              component="p"
              aria-live="polite"
              sx={{ fontSize: { xs: 26, md: 30 }, fontWeight: 700, lineHeight: 1.2, color: c.INK, fontVariantNumeric: 'tabular-nums', overflowWrap: 'anywhere' }}
            >
              {amount}
            </Typography>
          ) : null}
        </Box>
      </Box>
      {children}
      {actions ? <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>{actions}</Box> : null}
    </Paper>
  );
}
